"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_SESSION_PREFIX = void 0;
exports.USER_SESSION_PREFIX = "solidClientAuthenticationUser";
//# sourceMappingURL=ISessionInfoManager.js.map